import { publicConfigQuery$ } from '../firebase/queries/public-config/publicConfigQuery$';
import { useObservable } from './useObservable';

export const usePublicConfig = () => {
  return useObservable(() => publicConfigQuery$, 'public-config');
};
